export const GrayBox = ({ children, condition }) => {
  // TODO
  const color = {
    RED: getComputedStyle(document.body).getPropertyValue(
      '--wp--preset--color--vivid-red'
    )|| '#cf2e2e',
    BLUE: getComputedStyle(document.body).getPropertyValue(
      '--wp--preset--color--vivid-cyan-blue'
    )|| '#0693e3',
  }

  return (
    <p
      style={{
        background: '#ddd',
        padding: '18px',
        fontSize: '16px',
        fontWeight: 600,
        textAlign: 'center',
        color: condition ? color.BLUE : color.RED,
      }}
    >
      {children}
    </p>
  )
}
